import { fetchIsBettingAllowed } from 'modules/actions';
import { getParsedQS } from 'modules/utils/dom/index';
import { Events } from 'pages/landing/Events';
import { GuestEnterSection } from 'pages/landing/GuestEnterSection';
import { HowToPlaySection } from 'pages/landing/HowToPlaySection';
import { LandingHeaderSection } from 'pages/landing/LandingHeaderSection';
import { MGMSection } from 'pages/landing/MGMSection';
import { Terms } from 'pages/landing/Terms';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { AppSection } from 'pages/landing/AppSection';
import { HOCisTrue } from 'components/HOCisTrue';
import { get } from 'lodash';
import { getUser } from 'modules/selectors';

const LandingSection = styled.div`
  height: 100%;
`;

export const Landing = () => {
	const dispatch = useDispatch();
	const user = useSelector(getUser);
	const [isGuestVisible, setIsGuestVisible] = React.useState(false);

	const isBetting = getParsedQS().betting === 'true';
	const deviceType = get(user, 'device_type');
	const isApp = (deviceType === 'ios' || deviceType === 'android');

	const toggleVisibility = () => {
		setIsGuestVisible(!isGuestVisible);
	}

	useEffect(() => {
		dispatch(fetchIsBettingAllowed(isBetting));
	}, [dispatch, isBetting]);

	return (
		<LandingSection>
			<LandingHeaderSection toggleGuestVisibility={toggleVisibility}/>
			<HOCisTrue when={!isApp}>
				<AppSection/>
			</HOCisTrue>
			<GuestEnterSection visible={isGuestVisible}/>
			<Events/>
			<MGMSection/>
			<HowToPlaySection/>
			<Terms/>
		</LandingSection>
	);
}


export default Landing;
